import { ChevronRight } from 'lucide-react';
import { Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        'flex items-center text-sm text-muted-foreground',
        className,
      )}
    >
      <ol className="flex items-center gap-1 sm:gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <Fragment key={index}>
              <li className="flex items-center gap-1 sm:gap-2">
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className="hover:text-foreground transition-colors truncate max-w-[120px] sm:max-w-none"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    className={cn(
                      'truncate max-w-[120px] sm:max-w-none',
                      isLast && 'text-foreground font-medium',
                    )}
                  >
                    {item.label}
                  </span>
                )}
                {!isLast && (
                  <ChevronRight
                    className="h-4 w-4 flex-shrink-0"
                    aria-hidden="true"
                  />
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
